//funtion to escpape css classnames
export const escapeClassnames = (classnames: string): string => {
  return classnames.replace("+", "\\+");
};